import React, {useEffect, useState} from "react";
// Chakra imports
import {
    Alert,
    AlertDescription,
    AlertIcon,
    AlertTitle,
    Box,
    Button,
    CloseButton,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Input,
    Link,
    ScaleFade,
    Switch,
    Text,
    useColorModeValue,
} from "@chakra-ui/react";
// Assets
import signInImage from "assets/logo/logo.png";
import {signInUser} from "./services";
import {FORCED_LOGOUT_MESSAGE_KEY} from "../../utils/sessionUtils";
import {searchBellQueue} from "../../common-services";
import {setBellInfo} from "../../utils/BellStorageUtils";
import {hydrateAnnouncementsFromBackend} from "../../utils/AnnouncementStorageUtils";

function SignIn() {

    const [email, setEmail] = useState({})
    const [password, setPassword] = useState({})

    const [loginError, setLoginError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    // Surface a message left behind by an involuntary logout (e.g. a 401
    // "school blocked" response handled globally in axios), then consume it so
    // it doesn't reappear on the next visit to the login screen.
    useEffect(() => {
        const message = sessionStorage.getItem(FORCED_LOGOUT_MESSAGE_KEY);
        if (message) {
            setErrorMessage(message);
            setLoginError(true);
            sessionStorage.removeItem(FORCED_LOGOUT_MESSAGE_KEY);
        }
    }, []);

    const signIn = async () => {

        let requestDto = {
            email: email,
            password: password
        }

            async function fetchBellQueue() {
                try {
                    const response = await searchBellQueue();
                    if (response.status === 200) {
                        setBellInfo(response.data);
                    }
                } catch (e) {
                    console.error(e);
                }
            }

            await signInUser(requestDto)
                .then(async (response) => {
                    if (response.status === 200) {
                        const {data} = response;
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("username", data.username);

                        await localStorage.setItem("userInfo", JSON.stringify(data?.userInfo));

                       const userInfo=JSON.parse(localStorage.getItem("userInfo"));
                       console.log("userInfo from local staorage::",userInfo)
                        if (userInfo?.roleCode === 'USER') {
                            await fetchBellQueue();
                            // Pull the school's virtual announcements into local
                            // storage so the scheduler can reschedule them per the
                            // latest backend response.
                            await hydrateAnnouncementsFromBackend();
                        }

                        window.location.href = "/#/dashboard";
                    } else {
                        setErrorMessage(response?.data?.errorMessage || "");
                        setLoginError(true);
                    }
                })
                .catch((e) => {
                    console.log("error :::" + e);
                    setErrorMessage(e?.errorMessage || e?.message || "");
                    setLoginError(true);
                });

        }

        // Chakra color mode
        const titleColor = useColorModeValue("teal.300", "teal.200");
        const textColor = useColorModeValue("gray.400", "white");
        return (
            <Flex position='relative' mb='40px'>
                <Flex
                    h={{sm: "initial", md: "75vh", lg: "85vh"}}
                    w='100%'
                    maxW='1044px'
                    mx='auto'
                    justifyContent='space-between'
                    mb='30px'
                    pt={{sm: "100px", md: "0px"}}>
                    <Flex
                        alignItems='center'
                        justifyContent='start'
                        style={{userSelect: "none"}}
                        w={{base: "100%", md: "50%", lg: "42%"}}>
                        <Flex
                            direction='column'
                            w='100%'
                            background='transparent'
                            p='48px'
                            mt={{md: "150px", lg: "80px"}}>
                            <Heading color={titleColor} fontSize='32px' mb='10px'>
                                डिजिटल घण्टी प्रणालीमा स्वागत छ
                            </Heading>
                            <Text
                                mb='36px'
                                ms='4px'
                                color={textColor}
                                fontWeight='bold'
                                fontSize='14px'>
                                फेरि स्वागत छ लग इन गर्न
                            </Text>
                            <FormControl>
                                <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                                    इमेल
                                </FormLabel>
                                <Input
                                    borderRadius='15px'
                                    mb='24px'
                                    fontSize='sm'
                                    type='text'
                                    placeholder='Your email adress'
                                    size='lg'
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                                    पासवर्ड
                                </FormLabel>
                                <Input
                                    borderRadius='15px'
                                    mb='36px'
                                    fontSize='sm'
                                    type='password'
                                    placeholder='Your password'
                                    size='lg'
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <FormControl display='flex' alignItems='center'>
                                    <Switch id='remember-login' colorScheme='teal' me='10px'/>
                                    <FormLabel
                                        htmlFor='remember-login'
                                        mb='0'
                                        ms='1'
                                        fontWeight='normal'>
                                        Remember me
                                    </FormLabel>
                                </FormControl>

                                <ScaleFade in={loginError === true} unmountOnExit>
                                    <Alert
                                        status='error'
                                        variant='left-accent'
                                        borderRadius='12px'
                                        alignItems='flex-start'
                                        mb='20px'
                                        boxShadow='0 4px 12px rgba(229, 62, 62, 0.15)'>
                                        <AlertIcon />
                                        <Box flex='1'>
                                            <AlertTitle fontSize='sm'>लगइन असफल भयो!</AlertTitle>
                                            <AlertDescription fontSize='sm'>
                                                {errorMessage || "प्रयोगकर्ताको नाम वा पासवर्ड मेल खाँदैन।"}
                                            </AlertDescription>
                                        </Box>
                                        <CloseButton
                                            size='sm'
                                            onClick={() => setLoginError(false)}
                                            aria-label='Close error message'
                                        />
                                    </Alert>
                                </ScaleFade>

                                <Button
                                    fontSize='10px'
                                    type='submit'
                                    bg='teal.300'
                                    w='100%'
                                    h='45'
                                    mb='20px'
                                    color='white'
                                    mt='20px'
                                    _hover={{
                                        bg: "teal.200",
                                    }}
                                    _active={{
                                        bg: "teal.400",
                                    }}
                                    onClick={() => signIn()}
                                >
                                    साइन इन
                                </Button>
                            </FormControl>
                            <Flex
                                flexDirection='column'
                                justifyContent='center'
                                alignItems='center'
                                maxW='100%'
                                mt='0px'>
                                <Text color={textColor} fontWeight='medium'>
                                    Don't have an account?
                                    <Link
                                        color={titleColor}
                                        as='span'
                                        ms='5px'
                                        fontWeight='bold'
                                        cursor='pointer'
                                        onClick={() => (window.location.href = "/#/auth/signup")}>
                                        Sign Up
                                    </Link>
                                </Text>
                            </Flex>
                        </Flex>
                    </Flex>
                    <Box
                        display={{base: "none", md: "block"}}
                        overflowX='hidden'
                        h='100%'
                        w='40vw'
                        position='absolute'
                        right='0px'>
                        <Box
                            bgImage={signInImage}
                            w='100%'
                            h='100%'
                            bgSize='contain'
                            bgRepeat='no-repeat'
                            bgPosition='center'
                            position='absolute'
                            borderBottomLeftRadius='20px'></Box>
                    </Box>
                </Flex>
            </Flex>
        );
    }

    export default SignIn;
